import { createMuiTheme } from '@material-ui/core/styles';

export const themes = {

  default: createMuiTheme({
    palette: {
      primary: {
        light: '#d2ce56',
        main: '#9e9d24',
        dark: '#6c6f00',
        contrastText: '#fff',
      },
      secondary: {
        light: '#ffc046',
        main: '#ff8f00',
        dark: '#c56000',
        contrastText: '#000',
      },
    },
  }),
  red: createMuiTheme({
    palette: {
      primary: {
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
        contrastText: '#fff',
      },
      secondary: {
        light: '#757de8',
        main: '#3f51b5',
        dark: '#002984',
        contrastText: '#fff',
      },
    },
  }),
  narancs: createMuiTheme({
    palette: {
      primary: {
        light: '#ffa457',
        main: '#f77328',
        dark: '#bd4300',
        contrastText: '#fff',
      },
      secondary: {
        light: '#757de8',
        main: '#3f51b5',
        dark: '#002984',
        contrastText: '#fff',
      },
    },
  }),
  blue: createMuiTheme({
    palette: {
      primary: {
        light: '#757de8',
        main: '#3f51b5',
        dark: '#002984',
        contrastText: '#fff',
      },
      secondary: {
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
        contrastText: '#fff',
      },
    },
  }),
  green: createMuiTheme({
    palette: {
      primary: {
        light: '#99d066',
        main: '#689f38',
        dark: '#387002',
        contrastText: '#fff',
      },
      secondary: {
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
        contrastText: '#fff',
      },
    },
  })
}